import { memo } from 'react';

import { BaseButton, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { IAddress } from '@r1-frontend/shared/types/IAddress';

import AddressInputFields from '~/src/components/AddressInputFields';
import { POLICY_PAGE_LINK } from '~/src/constants';
import { useAnalytics } from '~/src/features/full-buy/analytics/context';

import * as ST from './styled';

export type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}

export type TContactDetailsProps = {
    isConfirmButtonActive: boolean,
    defaultAddress?: IAddress | null,
    showConfirmButton?: boolean,
    withSatelliteFilter?: boolean,
}

export type TContactDetailsCallbacks = {
    onFillAddress: (address: IAddress) => void,
    onConfirmBtnClick: () => void,
}

const EditableForm = ({
    isConfirmButtonActive,
    onFillAddress,
    onConfirmBtnClick,
    defaultAddress,
    showConfirmButton = true,
    withSatelliteFilter,
}: TContactDetailsProps & TContactDetailsCallbacks): JSX.Element => {
    const analytics = useAnalytics();

    return (
        <ST.EditableForm>
            <ST.BlockWrap>
                <AddressInputFields
                    catchAddressData={onFillAddress}
                    disableCityChange={true}
                    gtmCategory={analytics.category}
                    gtmSenderCallback={(action) => analytics.send(action)}
                    defaultAddress={defaultAddress}
                    withSatelliteFilter={withSatelliteFilter}
                />
                <IndentContainer $united={[12, 0, 0]}>
                    <PolicyNote
                        buttonText='Подтвердить'
                        agreeUrl={POLICY_PAGE_LINK}
                    />
                </IndentContainer>
            </ST.BlockWrap>
            {showConfirmButton &&
                <BaseButton
                    type={btnTypes.ACCENT}
                    text='Подтвердить'
                    onClick={onConfirmBtnClick}
                    disabled={!isConfirmButtonActive}
                />
            }
        </ST.EditableForm>
    );
};

export default memo(EditableForm);
